import {
  Autocomplete,
  Box,
  Button,
  Card,
  FormControl,
  IconButton,
  Stack,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import AddIcon from "@mui/icons-material/Add";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import dayjs from "dayjs";
import FileSaver from "file-saver";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { setSnackbar } from "../../../../util/state/globalAction";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import { ContextOperation } from "../../context/OperationContext";
import { transformationActions } from "../../service/transformation.action";
import GenericFilterBox from "../common/GenericFilterBox";
import { GenericTitleHeader } from "../common/GenericTitleHeader";
import { ConfirmationModalTransportator } from "./ConfirmationModalTransportator";
import UploadSuccessModal from "./UploadSuccessModal";
import SectionHeader from "../../../../util/component/SectionHeader";
import { useHasScope } from "../../../../config/globalConfig";
import useSnackbar from "../../hooks/useSnackbar";

export const TransportNavigationHeader = (props: any) => {
  const hasScope = useHasScope;
  const snackbar = useSnackbar();
  const { tenant, setLoading } = useContext(ContextOperation);
  const re = /^[0-9\b]+$/;
  const location = useLocation();
  const transformationService = transformationActions();
  const { t } = useTranslation(["operation"]);
  const { globalData, dispatchGlobalData } = React.useContext(GlobalContext);
  const tabOnePathname ="/operation/suppliers/transportator"
  const tabTwoPathname ="/operation/suppliers/transportator/pricelist"
  const tabThreePathname ="/operation/suppliers/transportator/promo"
  const [dataFormTabOne, setDataFormTabOne] = useState<any>({
    provinceStart: { id: "", descr: "" },
    provinceEnd: { id: "", descr: "" },
    dateTime: null,
  });
  const [dataFormTabTwo, setDataFormTabTwo] = useState<any>({
    kms: "",
    dateTime: null,
  });
  const [dataFormTabThree, setDataFormTabThree] = useState<any>({
    dateTime: null,
  });

  const [getSupplierArray, setSupplierArray] = useState<any>([]);
  const [supplierName, setSupplierName] = useState(null);
  const [statusActive, setStatusActive] = useState<boolean>(false);
  const [getSupplier, setSupplier] = useState<any>({
    ID: null,
    VAT: null,
    Status: statusActive,
  });
  const [getProvinceArray, setProvinceArray] = useState<any>([]);
  const desFirstValue = t(
    "transportSupplierPriceList.mainTitle.selectSupplier"
  );
  const [isSuccessUpload, setIsSuccessUpload] = useState<boolean>(false);
  const [buttonTitle, setButtonTitle] = useState<string>("");
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalPromo, setOpernModalPromo] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const messageNote = t(
    "transportSupplierPriceList.mainTitle.peruseTranslationMessage"
  );

  async function getFilters() {
    transformationService.getSupplier(tenant).then((response: any) => {
      setSupplierArray(response.data);
    });
    transformationService.getProvince().then((response: any) => {
      setProvinceArray(response.data);
    });
    if (props.getIdSupplier !== -1) {
      transformationService
        .PriceListStatus(tenant, props.getIdSupplier)
        .then((response: any) => {
          setStatusActive(response.data.active);
        });
    }
  }

  const handleChangeProvince = (event: any, type: any) => {
    setDataFormTabOne({
      ...dataFormTabOne,
      [type]: {
        ...dataFormTabOne?.[type],
        id: event?.id ? event?.id : "",
        descr: event?.descr ? event?.descr : "",
      },
    });
  };

  const onChange = (e: any) => {
    if (e === null || e.id === -1) {
      setSupplierName(null);
      props.setHasSupplierId(false);
      setDataFormTabOne({
        provinceStart: { id: "", descr: "" },
        provinceEnd: { id: "", descr: "" },
        dateTime: null,
      });
      setDataFormTabTwo({
        kms: "",
        dateTime: null,
      });
      setDataFormTabThree({
        dateTime: null,
      });
      props.setDataSearchFormOne(null);
      props.setDataSearchFormTwo(null);
      props.setDataSearchFormThree(null);
    } else {
      setSupplierName(e);
      props.setIdSupplier(e.id);
      props.setHasSupplierId(true);
      getStatusOfSupplier(e.id);
      setSupplier({
        ...getSupplier,
        ID: e.descr,
        VAT: e.vat,
        Status: statusActive,
      });
    }
  };
  //Test

  async function updateAction() {
    setLoading(true);
    transformationService
      .ChangePriceListsActivation(tenant, props.getIdSupplier, !statusActive)
      .then((response: any) => {
        getStatusOfSupplier(props.getIdSupplier);
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
      });

    props.setRefreshPage(props.refreshPage);
  }

  const lockSupplier = () => {
    setOpenModal(true);
    if (statusActive === false) {
      setTitle(t("transportSupplierPriceList.mainTitle.unlockConfirmation"));
      let messages1 = t(
        "transportSupplierPriceList.mainTitle.unlockConfirmationMessage",
        {
          supplier: getSupplier.ID,
        }
      );
      setMessage(messages1);
      setButtonTitle(t("transportSupplierPriceList.mainTitle.unlock"));
    } else if (statusActive === true) {
      setTitle(t("transportSupplierPriceList.mainTitle.lockConfirmation"));
      let messages1 = t(
        "transportSupplierPriceList.mainTitle.lockConfirmationMessage",
        {
          supplier: getSupplier.ID,
        }
      );
      setMessage(messages1);
      setButtonTitle(t("transportSupplierPriceList.mainTitle.lock"));
    }
  };

  const downloadTemplate = () => {
    setLoading(true);
    transformationService.downloadTemplate().then((response: any) => {
      setLoading(false);
      const filename =
        response?.headers["content-disposition"].split("filename=")[1];
      var blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(blob, filename);
    });
  };

  const onImageChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      const formData = new FormData();
      formData.append("file", img);
      if (img) {
        setLoading(true);
        transformationService
          .uploadPriceList(tenant, props.getIdSupplier, formData)
          .then((response: any) => {
            setLoading(false);
            setIsSuccessUpload(true);
          })
          .catch((error: any) => {
            if (
              error.response.data.code === 400 &&
              error.response.data.subCode === 1
            ) {
              setLoading(false);
              snackbar.show(
                "error",
                t("transportSupplierPriceList.uploadErrorMssg.notValid")
              );
            } else if (
              error.response.data.code === 409 &&
              error.response.data.subCode === 2
            ) {
              setLoading(false);
              snackbar.show(
                "error",
                t("transportSupplierPriceList.uploadErrorMssg.doesNotMatch")
              );
            } else {
              setLoading(false);
              snackbar.show("error", error.response.data.msg);
            }
          });
      }
      event.target.value = null;
    }
  };

  const getStatusOfSupplier = (id: any) => {
    transformationService.PriceListStatus(tenant, id).then((response: any) => {
      setStatusActive(response.data.active);
      // props.setRefreshPage(!props.refreshPage)
    });
  };

  const openModalForCreate = () => {
    props.setOpenDialog(true);
  };
  const onSearch = (e: any) => {
    e.preventDefault();
    switch (location.pathname) {
      case tabOnePathname:
        props.setDataSearchFormOne(dataFormTabOne);
        props.setRefreshPage(!props.refreshPage);
        break;
      case tabTwoPathname:
        props.setDataSearchFormTwo(dataFormTabTwo);
        props.setRefreshPage(!props.refreshPage);
        break;
      case tabThreePathname:
        props.setDataSearchFormThree(dataFormTabThree);
        props.setRefreshPage(!props.refreshPage);
        break;
    }
    return;
  };

  const onResetFilter = () => {
    setSupplierName(null);
    props.setTenant(tenant);
    props.setHasSupplierId(false);
    if (props.hasSupplierId) {
      switch (location.pathname) {
        case tabOnePathname:
          setDataFormTabOne({
            provinceStart: { id: "", descr: "" },
            provinceEnd: { id: "", descr: "" },
            dateTime: null,
          });
          props.setDataSearchFormOne(null);
          props.setRefreshPage(!props.refreshPage);
          break;
        case tabTwoPathname:
          setDataFormTabTwo({
            kms: "",
            dateTime: null,
          });
          props.setDataSearchFormTwo(null);
          props.setRefreshPage(!props.refreshPage);
          break;
        case tabThreePathname:
          setDataFormTabThree({
            dateTime: null,
          });
          props.setDataSearchFormThree(null);
          props.setRefreshPage(!props.refreshPage);
          break;
      }
    }
    return;
  };

  const maipulateProvinceValue = () => {
    return getProvinceArray.map((response: any) => ({
      descr: `${response?.descr} (${response?.code})`,
      id: response.id,
    }));
  };

  //Finish
  useEffect(() => {
    setSupplierName(null);
    props.setTenant(tenant);
    props.setHasSupplierId(false);
    setDataFormTabOne({
      provinceStart: { id: "", descr: "" },
      provinceEnd: { id: "", descr: "" },
      dateTime: null,
    });
    setDataFormTabTwo({
      kms: "",
      dateTime: null,
    });
    setDataFormTabThree({
      dateTime: null,
    });
    props.setDataSearchFormOne(null);
    props.setDataSearchFormTwo(null);
    props.setDataSearchFormThree(null);
  }, [tenant]);

  useEffect(() => {
    //props.setIdSupplier(-1)
    getFilters();
  }, [props.refreshPage, tenant]);
  return (
    <>
      <SectionHeader
        title={
          t("transportSupplierPriceList.mainTitle.transportSupplierTitle") +
          " " +
          t("transportSupplierPriceList.mainTitle.priceListTitle")
        }
        subtitle={
          props.hasSupplierId && (
            <Stack direction={"row"} spacing={3}>
              <Box>
                <Stack direction={"row"} alignItems="flex-end">
                  <Box fontSize={16} fontWeight={700}>
                    {t("transportSupplierPriceList.mainTitle.id")}:&nbsp;
                  </Box>{" "}
                  <Box>{getSupplier.ID}</Box>
                </Stack>
              </Box>
              <Box>
                <Stack direction={"row"} alignItems="flex-end">
                  <Box fontSize={16} fontWeight={700}>
                    {t("transportSupplierPriceList.mainTitle.vat")}:&nbsp;
                  </Box>{" "}
                  <Box>{getSupplier.VAT}</Box>
                </Stack>
              </Box>
              <Box>
                <Stack direction={"row"} alignItems="flex-end">
                  <Box fontSize={16} fontWeight={700}>
                    {t("transportSupplierPriceList.mainTitle.status")}:&nbsp;
                  </Box>{" "}
                  <Box>
                    {!statusActive
                      ? t("transportSupplierPriceList.mainTitle.locked")
                      : t("transportSupplierPriceList.mainTitle.unlocked")}
                  </Box>
                </Stack>
              </Box>
            </Stack>
          )
        }
      />
      <Box component={"div"} pl={2} pr={2}>
        <Tabs
          sx={{ boxShadow: "0px -4px 0px rgba(151, 151, 151, 0.2) inset" }}
          TabIndicatorProps={{
            sx: {
              height: "5px",
              backgroundColor: "rgba(200, 1, 125, 1)",
            },
          }}
          value={location.pathname}
          aria-label="basic tabs example"
        >
          <Tab
            to={"/operation/suppliers/transportator"}
            component={Link}
            label={
              <Box>
                <Typography>
                  {t(
                    "transportSupplierPriceList.titleNavigation.priceListPerRoute"
                  )}
                </Typography>
              </Box>
            }
            value={"/operation/suppliers/transportator"}
          ></Tab>
          <Tab
            to={"/operation/suppliers/transportator/pricelist"}
            component={Link}
            label={
              <div>
                <Typography>
                  {t(
                    "transportSupplierPriceList.titleNavigation.priceListPerKm"
                  )}
                </Typography>
              </div>
            }
            value={"/operation/suppliers/transportator/pricelist"}
          ></Tab>
          <Tab
            to={"/operation/suppliers/transportator/promo"}
            component={Link}
            label={
              <div>
                <Typography>
                  {t(
                    "transportSupplierPriceList.titleNavigation.promoIncreases"
                  )}
                </Typography>
              </div>
            }
            value={"/operation/suppliers/transportator/promo"}
          ></Tab>
        </Tabs>
      </Box>
      <Box>
        <>
          <form id="idTransportFormList" onSubmit={(e) => onSearch(e)}>
            <GenericFilterBox
              formId="idTransportFormList"
              onReset={onResetFilter}
              showExtrasFilters={
                location.pathname === tabOnePathname && props.hasSupplierId
                  ? true
                  : false
              }
            >
              <Box>
                <Autocomplete
                  disablePortal
                  sx={{
                    "&.MuiAutocomplete-root": {
                      "& button[title='Clear']": {
                        visibility: "visible",
                      },
                    },
                  }}
                  value={supplierName}
                  onChange={(event, value) => {
                    event.stopPropagation();
                    onChange(value);
                  }}
                  options={getSupplierArray.map((response: any) => response)}
                  getOptionLabel={(option: any) => option.descr}
                  renderOption={(props, option, state) => {
                    return (
                      <li {...props} key={props.id}>
                        {option.descr}
                      </li>
                    );
                  }}
                  renderInput={(params: any) => (
                    <TextField
                      variant="standard"
                      fullWidth
                      {...params}
                      label={desFirstValue}
                    />
                  )}
                />
              </Box>

              {props.hasSupplierId && location.pathname === tabOnePathname && tenant !== "drivalia_fr" && (
                <>
                  <Box>
                    <Autocomplete
                      disablePortal
                      sx={{
                        "&.MuiAutocomplete-root": {
                          "& button[title='Clear']": {
                            visibility: "visible",
                          },
                        },
                      }}
                      disableClearable={
                        dataFormTabOne.provinceStart.id ? false : true
                      }
                      id="idProvinceStart"
                      value={{
                        id: dataFormTabOne.provinceStart.id,
                        descr: dataFormTabOne.provinceStart.descr,
                      }}
                      options={maipulateProvinceValue()}
                      getOptionLabel={(option: any) => option?.descr}
                      onChange={(e, value) => {
                        e.stopPropagation();
                        handleChangeProvince(value, "provinceStart");
                      }}
                      renderOption={(props, option, state) => {
                        return (
                          <li {...props} key={props.id}>
                            {option?.descr}
                          </li>
                        );
                      }}
                      renderInput={(params: any) => (
                        <TextField
                          fullWidth
                          variant="standard"
                          {...params}
                          label={t(
                            "transportSupplierPriceList.priceListRouteTable.filterModel.startProvinceLabel"
                          )}
                        />
                      )}
                    />
                  </Box>
                  <Box>
                    <Autocomplete
                      disablePortal
                      sx={{
                        "&.MuiAutocomplete-root": {
                          "& button[title='Clear']": {
                            visibility: "visible",
                          },
                        },
                      }}
                      disableClearable={
                        dataFormTabOne.provinceEnd.id ? false : true
                      }
                      id="provinceEnd"
                      value={{
                        id: dataFormTabOne.provinceEnd.id,
                        descr: dataFormTabOne.provinceEnd.descr,
                      }}
                      options={maipulateProvinceValue()}
                      getOptionLabel={(option: any) => option?.descr}
                      onChange={(e, value) => {
                        e.stopPropagation();
                        handleChangeProvince(value, "provinceEnd");
                      }}
                      renderOption={(props, option, state) => {
                        return (
                          <li {...props} key={props.id}>
                            {option.descr}
                          </li>
                        );
                      }}
                      renderInput={(params: any) => (
                        <TextField
                          fullWidth
                          variant="standard"
                          {...params}
                          label={t(
                            "transportSupplierPriceList.priceListRouteTable.filterModel.destinationProvinceLabel"
                          )}
                        />
                      )}
                    />
                  </Box>

                  <Box>
                    <DatePicker
                      views={["day"]}
                      label={t(
                        "transportSupplierPriceList.promoIncreasesTable.date"
                      )}
                      value={dataFormTabOne.dateTime}
                      inputFormat={"DD/MM/YYYY"}
                      mask={"__/__/____"}
                      onChange={(e: any) => {
                        setDataFormTabOne({
                          ...dataFormTabOne,
                          dateTime: e,
                        });
                      }}
                      renderInput={(params: any) => (
                        <TextField {...params} fullWidth />
                      )}
                    />
                  </Box>
                </>
              )}
              {props.hasSupplierId && location.pathname === tabTwoPathname && (
                <>
                  <Box>
                    <TextField
                      fullWidth
                      label={t(
                        "transportSupplierPriceList.priceListPerKMTable.filterModal.kmRange"
                      )}
                      variant="standard"
                      id="kms"
                      name="kms"
                      value={dataFormTabTwo.kms}
                      onChange={(event: any) => {
                        if (
                          event.target.value === "" ||
                          re.test(event.target.value)
                        ) {
                          setDataFormTabTwo({
                            ...dataFormTabTwo,
                            kms: event.target.value,
                          });
                        }
                      }}
                    />
                  </Box>

                  <Box>
                    <DatePicker
                      views={["day"]}
                      label={t(
                        "transportSupplierPriceList.promoIncreasesTable.date"
                      )}
                      value={dataFormTabTwo.dateTime}
                      inputFormat={"DD/MM/YYYY"}
                      mask={"__/__/____"}
                      onChange={(e: any) => {
                        setDataFormTabTwo({
                          ...dataFormTabTwo,
                          dateTime: e,
                        });
                      }}
                      renderInput={(params: any) => (
                        <TextField {...params} fullWidth />
                      )}
                    />
                  </Box>
                </>
              )}
              {props.hasSupplierId &&
                location.pathname === tabThreePathname && (
                  <>
                    <Box>
                      <DatePicker
                        views={["day"]}
                        label={t(
                          "transportSupplierPriceList.promoIncreasesTable.date"
                        )}
                        value={dataFormTabThree.dateTime}
                        inputFormat={"DD/MM/YYYY"}
                        mask={"__/__/____"}
                        onChange={(e: any) => {
                          setDataFormTabThree({
                            ...dataFormTabThree,
                            dateTime: e,
                          });
                        }}
                        renderInput={(params: any) => (
                          <TextField {...params} fullWidth />
                        )}
                      />
                    </Box>
                  </>
                )}
            </GenericFilterBox>
          </form>
        </>
      </Box>
      <Box ml={2} mr={2}>
        <Card>
          {globalData.user.username !== "operationviewer" && (
            <Stack
              pr={1}
              spacing={1}
              direction={"row"}
              minHeight={46}
              display="flex"
              justifyContent={"flex-end"}
              alignItems="center"
            >
              {location.pathname !== tabThreePathname &&
                (hasScope("SCOPE_CREATE_MDTRANSPORTATION_SUPPLIER") ||
                  hasScope("SCOPE_UPDATE_MDTRANSPORTATION_SUPPLIER")) && (
                  <>
                    <Box>
                      <Button
                        variant="outlined"
                        onClick={downloadTemplate}
                        startIcon={<FileDownloadIcon />}
                      >
                        <Typography color={"accent"} fontWeight={700}>
                          {t(
                            "transportSupplierPriceList.templateButton.downloadTemplate"
                          )}
                        </Typography>
                      </Button>
                    </Box>

                    <Box>
                      <label htmlFor="upload-photo">
                        <input
                          disabled={!props.hasSupplierId}
                          style={{ display: "none" }}
                          id="upload-photo"
                          onChange={onImageChange}
                          name="upload-photo"
                          type="file"
                        />
                        <Button
                          component="span"
                          color="accent"
                          disabled={!props.hasSupplierId}
                          startIcon={<FileUploadIcon />}
                        >
                          <Typography
                            color={!props.hasSupplierId ? "accent" : "white"}
                            fontWeight={700}
                          >
                            {t(
                              "transportSupplierPriceList.templateButton.uploadPriceList"
                            )}
                          </Typography>
                        </Button>
                      </label>
                    </Box>
                  </>
                )}
              {statusActive === true &&
              hasScope("SCOPE_UPDATE_MDTRANSPORTATION_SUPPLIER") ? (
                <IconButton
                  disabled={!props.hasSupplierId}
                  color="accent"
                  onClick={lockSupplier}
                >
                  <Tooltip
                    title={t("transportSupplierPriceList.mainTitle.lock")}
                  >
                    <LockIcon />
                  </Tooltip>
                </IconButton>
              ) : (
                <>
                  {hasScope("SCOPE_UPDATE_MDTRANSPORTATION_SUPPLIER") && (
                    <IconButton
                      disabled={!props.hasSupplierId}
                      color="accent"
                      onClick={lockSupplier}
                    >
                      <Tooltip
                        title={t("transportSupplierPriceList.mainTitle.unlock")}
                      >
                        <LockOpenOutlinedIcon />
                      </Tooltip>
                    </IconButton>
                  )}
                </>
              )}

              {location.pathname === tabThreePathname &&
                (hasScope("SCOPE_CREATE_MDTRANSPORTATION_SUPPLIER") ||
                  hasScope("SCOPE_UPDATE_MDTRANSPORTATION_SUPPLIER")) && (
                  <Box>
                    <IconButton
                      disabled={!props.hasSupplierId}
                      color="accent"
                      onClick={openModalForCreate}
                    >
                      <Tooltip
                        title={t(
                          "transportSupplierPriceList.templateButton.addNewPromo"
                        )}
                      >
                        <AddIcon />
                      </Tooltip>
                    </IconButton>
                  </Box>
                )}
            </Stack>
          )}
        </Card>
        {isSuccessUpload && (
          <UploadSuccessModal closeModal={setIsSuccessUpload} />
        )}

        {openModal && (
          <ConfirmationModalTransportator
            setOpen={openModal}
            onClose={() => setOpenModal(false)}
            title={title}
            message={message}
            messageNote={messageNote}
            cancel={t("actionButtons.cancel")}
            confirm={buttonTitle}
            updateAction={updateAction}
          />
        )}
      </Box>
    </>
  );
};
